import { Endpoints } from "../../../constants/endpoints";
import { TTeamRaw } from "./types";
import client from "../../client";

export const getTeam = (companyId?: string | number | null) => async () => {
  // if (!companyId) return [];
  const { data } = await client.get<TTeamRaw>(Endpoints.getTeam(companyId!));
  return data;
};
